import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormWrapperComponent } from '../../../ui/form-wrapper/form-wrapper.component';
import { MessagesService, SavedMessages } from '../../../../services/campaign/messages.service';
import { ScheduleService } from '../../../../services/campaign/schedule.service';
import { CampaignStepperService } from '../../../../services/campaign/campaign-stepper.service';
import { smsParts } from '../../../../../utils/sms';

/** Step 3: the messages added so far, each editable or removable in place. */
@Component({
  selector: 'app-campaign-messages',
  standalone: true,
  imports: [FormWrapperComponent, MatTooltipModule],
  templateUrl: './campaign-messages.component.html',
  styleUrl: '../campaign-preview.css',
})
export class CampaignMessagesComponent {
  @Output() openPopupEvent = new EventEmitter<string | number>();
  messagesService = inject(MessagesService);
  private scheduleService = inject(ScheduleService);
  private stepper = inject(CampaignStepperService);

  constructor(private router: Router, private route: ActivatedRoute) {}

  /** "1 part", "3 parts". */
  partsLabel(body: string | null | undefined): string {
    const { parts, estimated } = smsParts(body);
    const count = parts === 1 ? '1 part' : `${parts} parts`;
    return estimated ? `About ${count}` : count;
  }

  updateQueryParams(id: number | string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { edit: id },
      queryParamsHandling: 'merge', // merge with existing query params
    });
  }

  deleteMessage(id: string, event: MouseEvent) {
    event.stopPropagation();
    // deleteSavedMessage removes the last message when the id is unknown; only call it for a real one.
    if (!this.messagesService.savedMessages.some((item) => item.id === id)) return;
    this.messagesService.deleteSavedMessage(id);
    // Its send times go with it, so nothing is scheduled for a message that no longer exists.
    this.scheduleService.messageSchedule = this.scheduleService.messageSchedule.filter(
      (schedule) => schedule.message?.id !== id
    );
    // With no messages left, the steps after this one wait until one is added.
    if (!this.messagesService.savedMessages.length) {
      const step = this.stepper.steps.find((item) => item.slug === 'messages');
      if (step) step.completed = false;
    }
  }

  openPopup(message: SavedMessages, msgNo: number | string) {
    this.updateQueryParams(message.id);
    this.openPopupEvent.emit(msgNo);
  }
}
